/**
 * Plain options bag for Intl.NumberFormat. Types match the modern lib so it
 * can be passed directly to `new Intl.NumberFormat(locale, options)` without
 * casts. The previous declaration used `string` which was accepted by older
 * TypeScript but rejects under the stricter 4.x+ `lib.es2020.intl.d.ts`.
 */
export class NumberFormat implements Intl.NumberFormatOptions {
  localeMatcher?: "lookup" | "best fit";
  style?: "decimal" | "currency" | "percent" | "unit";
  currency?: string;
  currencyDisplay?: "symbol" | "narrowSymbol" | "code" | "name";
  useGrouping?: boolean;
  minimumIntegerDigits?: number;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  minimumSignificantDigits?: number;
  maximumSignificantDigits?: number;
}
